import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Styles from '../Config/Styles';
import { storage } from '../Config/Storage';
import { BUYMATERIAL, INFO, LOGIN } from '../Routes/constURL';
import { useNavigate } from 'react-router-dom';
import AlertBox from './AlertBox';
import { generateSessionToken } from '../Config/Util';
import { getSwipped } from '../Redux/Categories/action';
import { useDispatch } from 'react-redux';

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loggedIn = storage.fetch.auth();
  const [data, setData] = useState([
    { name: 'Buy Material', route: BUYMATERIAL },
    { name: 'Login / Register', route: LOGIN },
  ]);
  const [open, setOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null); // For responsive menu

  useEffect(() => {
    if (loggedIn) {
      setData([
        { name: 'Buy Material', route: BUYMATERIAL },
        { name: 'Profile', route: INFO },
        { name: 'Logout' },
      ]);
    } else {
      setData([
        { name: 'Buy Material', route: BUYMATERIAL },
        { name: 'Login / Register', route: LOGIN },
      ]);
    }
  }, [loggedIn]);

  const handleClick = (route) => {
    if (!route) {
      setOpen(true);
    } else {
      navigate(route);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    storage.destory.auth();
    storage.destory.phone();
    storage.destory.phonenumber();
    storage.destory.loggedinuser();
    storage.destory.rfq();
    storage.destory.rfqID();
    generateSessionToken()
    setOpen(false);
    navigate(LOGIN);
  };

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleDrawer = () => {
    dispatch(getSwipped(true))
  }
  return (
    <AppBar sx={Styles.HeaderStyle.appbar}>
      <AlertBox
        open={open}
        onClickButton={handleConfirm}
        onClickButtonCancel={handleCancel}
      />
      <Toolbar sx={Styles.HeaderStyle.toolbar}>
        {/* Logo Section */}
        <IconButton onClick={handleDrawer}>
          <Box sx={Styles.HeaderStyle.box}>
            <img
              src={require('../assets/Logo.png')}
              alt="Logo"
              style={Styles.HeaderStyle.img}
            />
          </Box>
        </IconButton>
        {/* Navigation Links - Desktop */}
        <Box
          sx={Styles.HeaderStyle.box1}
        >
          {data?.map((item, ind) => (
            <Button
              key={ind}
              color="inherit"
              onClick={() => handleClick(item?.route)}
              sx={Styles.HeaderStyle.link}
            >
              {item.name}
            </Button>
          ))}
        </Box>

        {/* Navigation Menu - Mobile */}
        <Box
          sx={Styles.HeaderStyle.iconbox}
        >
          <IconButton
            color="inherit"
            edge="end"
            onClick={handleMenuOpen}
            sx={Styles.HeaderStyle.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={handleMenuClose}
          >
            {data?.map((item, ind) => (
              <MenuItem
                key={ind}
                onClick={() => {
                  handleClick(item?.route);
                  handleMenuClose();
                }}
              >
                {item.name}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
